module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Ciara Platt is a young woman from North Idaho. Ever since she was a child, she’s found solace in writing and sharing her thoughts. In 2022, she was hospitalized for schizoaffective disorder, bipolar type. She has since decided to share her journey with others in hopes that it would help normalize mental health and help others feel less alone. She is happily married with two small babies and finds great comfort in being a mom. She hopes to continue to use her voice as a tool to help end the stigma surrounding on mental health and encourages those around her to do the same.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0